<div *ngIf="this.url" style="text-align: left;">
  <img [src]="this.url" [attr.alt]="getAltText()"  [ngStyle]="{'width.em': (20/100)*(element.scale)}" [class.no-max-width]="!!element.unlockMaxWidth" />
</div>
